var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.markers.length)?_c('LeafletMap',{staticClass:"vue-leaflet",staticStyle:{"position":"absolute","width":"100%","height":"100%"},attrs:{"markers":_vm.markers}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }